import type { FirestoreDataConverter } from '~/types/firestore'
import type { LeaderboardUserMetadata } from '~/types/leaderboard'
import type { UserDisplayMetadata } from '~/types/user'

export const leaderboardUserMetadataConverter: FirestoreDataConverter<
    UserDisplayMetadata,
    LeaderboardUserMetadata
> = {
    fromFirestore: (snapshot, options) => {
        const data = snapshot.data(options)

        const userMetadata = {
            name: data.displayName,
            pdgaNumber: data.pdgaNumber,
            photo: data.photoUrl,
        }

        return userMetadata
    },
    toFirestore: modelObject => {
        const toDB = {
            displayName: modelObject.name,
            pdgaNumber: modelObject.pdgaNumber,
            photoUrl: modelObject.photo,
        }

        return toDB
    },
}
